import Vue from 'vue'
import App from './App'
import router from './router'
import http from '@/api/http'
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import { Popup, Area, ActionSheet, Sticky } from 'vant';

Vue.use(Popup).use(Area).use(ActionSheet).use(Sticky);

require('es6-promise').polyfill()
Es6Promise.polyfill()

Vue.config.productionTip = false
Vue.prototype.$http = http;
Vue.prototype.$globalData = {};

// 开发环境mock测试
if (process.env.NODE_ENV === 'development') {
    // http.defaults.baseURL = '/'
    http.defaults.baseURL = 'http://yueyuan-api.js.yueyuan1314.com'
} else if (process.env.NODE_ENV === 'preview') {
    http.defaults.baseURL = 'http://iudating.cn'
} else {
    http.defaults.baseURL = 'https://api.yueyuanapp.com'
}
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})

const BrowserLogger = require('alife-logger');
const __bl = BrowserLogger.singleton({pid:"hkoflo53rz@071b2c60d5d21b6",appType:"web",imgUrl:"https://arms-retcode.aliyuncs.com/r.png?",sendResource:true,enableLinkTrace:true,behavior:true,enableSPA:true,useFmp:true});


// WEBPACK FOOTER //
// ./src/main.js